import React from 'react'
import IconButton from '@material-ui/core/IconButton'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'

const DebugDrawerCloseButton = ({ handleClose }) => (
  <IconButton onClick={handleClose}>
    <ChevronRightIcon />
  </IconButton>
)

export default DebugDrawerCloseButton



// WEBPACK FOOTER //
// ./src/debug/DebugDrawerCloseButton.js